import React from "react";

const Articles = () => {
  return (
    <div>
      <main>
        <section className=" pt-5 mt-5 mb-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 mt-2">
                <div className="main_title">
                  <h2 className="h2 text-primary">Articles</h2>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-secondary-light px-80 pb-5">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-6 mb-4">
                <div className="feature_box-shadow d-flex flex-column p-4 h-100">
                  <div className="w-100 mb-3">
                    <img
                      src="/assets/images/Article%201.jpg"
                      alt="Tokenization and the New Digital Frontier of Islamic Finance"
                      className="img-fluid w-100"
                    />
                  </div>
                  <div className="flex-grow-1 d-flex flex-column">
                    <h3 className="fs-18 text-primary fw-bold mb-3">
                      Tokenization and the New Digital Frontier of Islamic Finance
                    </h3>
                    <a
                      href="https://businessconnectindia.in/tokenisation-new-digital-frontier-of-islamic-finance/"
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary mt-auto align-self-start"
                    >
                      Read Article
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-6 mb-4">
                <div className="feature_box-shadow d-flex flex-column p-4 h-100">
                  <div className="w-100 mb-3">
                    <img
                      src="/assets/images/Article%202.jpeg"
                      alt="Shariah-Compliant RWA Tokenization and Ethical Profit"
                      className="img-fluid w-100"
                    />
                  </div>
                  <div className="flex-grow-1 d-flex flex-column">
                    <h3 className="fs-18 text-primary fw-bold mb-3">
                      Shariah-Compliant RWA Tokenization and Ethical Profit
                    </h3>
                    <a
                      href="https://businessconnectindia.in/shariah-compliant-rwa-tokenisation/"
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary mt-auto align-self-start"
                    >
                      Read Article
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-6 mb-4 mx-lg-auto">
                <div className="feature_box-shadow d-flex flex-column p-4 h-100">
                  <div className="w-100 mb-3">
                    <img
                      src="/assets/images/Article%203.png"
                      alt="How real-world assets and tokenization bring gold on blockchain"
                      className="img-fluid w-100"
                    />
                  </div>
                  <div className="flex-grow-1 d-flex flex-column">
                    <h3 className="fs-18 text-primary fw-bold mb-3">
                      How real-world assets and tokenization bring gold on blockchain
                    </h3>
                    <a
                      href="/assets/pdf/v23i07-26-27.pdf"
                      className="btn btn-primary mt-auto align-self-start"
                      download
                    >
                      Download PDF
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 mb-4 mx-lg-auto">
                <div className="feature_box-shadow d-flex flex-column p-4 h-100">
                  <div className="w-100 mb-3">
                    <img
                      src="/assets/images/Article%204.png"
                      alt="Blockchain and trade finance in Islamic finance"
                      className="img-fluid w-100"
                    />
                  </div>
                  <div className="flex-grow-1 d-flex flex-column">
                    <h3 className="fs-18 text-primary fw-bold mb-3">
                    Blockchain and trade finance in Islamic finance
                    </h3>
                    <a
                      href="/assets/pdf/Blockchain and trade finance in Islamic finance.pdf"
                      className="btn btn-primary mt-auto align-self-start"
                      download
                    >
                      Download PDF
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 mb-4 mx-lg-auto">
                <div className="feature_box-shadow d-flex flex-column p-4 h-100">
                  <div className="w-100 mb-3">
                    <img
                      src="/assets/images/Article%205.png"
                      alt="World Eco magazine"
                      className="img-fluid w-100"
                    />
                  </div>
                  <div className="flex-grow-1 d-flex flex-column">
                    <h3 className="fs-18 text-primary fw-bold mb-3">
                      World Eco magazine
                    </h3>
                    <a
                      href="/assets/pdf/World Eco magazine.pdf"
                      className="btn btn-primary mt-auto align-self-start"
                      download
                    >
                      Download PDF
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Articles;
